<footer class="container-fluid p-5 bg-second-gray ">
  <div class="row">
    <div class="col-lg-3 d-flex flex-column justify-content-top">
      <img src="assets/images/shared/logo-broadfactor-white-letter.png" alt="Logo da Broadfactor" class="w-logo mb-4">
    </div>
    <div class="col-lg-2">
      <b>Broadfactor</b>
      <ul>
        <li><a [href]="globalData.getBroadWebsite().aboutUs" target="_blank">Sobre nós</a></li>
        <li><a [href]="globalData.getBlogBroadfactor()" target="_blank">Blog</a></li>
      </ul>
    </div>
    <div class="col-lg-2">
      <b>Ajuda</b>
      <ul>
        <li><a routerLink="central-de-ajuda">Central de Ajuda</a></li>
        <li><a [href]="globalData.getDocumentsAwsUrl().termsOfUse" target="_blank">Termos de Uso</a></li>
        <li><a [href]="globalData.getDocumentsAwsUrl().privacyPolicy" target="_blank">Política de Privacidade (LGPD)</a></li>
      </ul>
    </div>
    <div class="col-lg-3">
      <b>Canais de atendimento</b>
      <ul>
        <li>suporte&#64;broadfactor.com</li>
        <li>{{globalData.getContactNumber().formatted}}</li>
      </ul>
    </div>

    <div class="col-lg-2 mb-4">
      <b class="mb-2">Redes Sociais</b>
      <app-social-media [color]="'white'"></app-social-media>
    </div>

  </div>

  <section class="row d-flex justify-content-end">
    <figure class="col-lg-2 text-center">
      <img src="assets/images/footer/fintech.svg" alt="Certificado Fintech Segura Nível 1">
    </figure>
  </section>
  <div class="d-flex flex-column align-items-center mt-3 body-small-bold footer-info">
    Copyright 2024 Broadfactor Sistema e Apoio Administrativo CNPJ: 13.995.981/0001-04 | Todos os direitos reservados
  </div>
</footer>
